import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import PATHS from './routesMap'

import Auth from '../views/auth/Auth.vue'

const routes = [
  {
    name: 'Auth',
    path: PATHS.AUTH,
    component: Auth,
  },
  {
    name: 'Home',
    path: PATHS.HOME,
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Admin',
    path: PATHS.ADMIN,
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Admin.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'AdminOrcamentos',
    path: PATHS.ADMIN_ORCAMENTOS,
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Orcamentos.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'AdminSincronizacoes',
    path: PATHS.ADMIN_SINCRONIZACOES,
    component: () =>
      import(
        /* webpackChunkName: "admin" */ '../views/admin/Sincronizacoes.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'AdminCCBloqueados',
    path: PATHS.ADMIN_CC_BLOQUEADOS,
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/CCBloqueados.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'AdminUsuariosPermisao',
    path: PATHS.ADMIN_USUARIOS_PERMISSAO,
    component: () =>
      import(
        /* webpackChunkName: "admin" */ '../views/admin/UsuariosPermissao.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'AdminImportacao',
    path: PATHS.ADMIN_IMPORTACAO,
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Importacao.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'CCDetalhes',
    path: PATHS.CC_DETALHES,
    component: () =>
      import(
        /* webpackChunkName: "centroCusto" */ '../views/centroCusto/CCPaiDetalhes.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Preenchimento',
    path: PATHS.PREENCHIMENTO,
    component: () =>
      import(
        /* webpackChunkName: "preenchimento" */ '../views/preenchimento/Preenchimento.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Metas',
    path: PATHS.METAS,
    component: () =>
      import(/* webpackChunkName: "metas" */ '../views/metas/Metas.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Relatorios',
    path: PATHS.RELATORIOS,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/Relatorios.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RelatorioConferirPreenchimento',
    path: PATHS.RELATORIO_CONFERIR_PREENCHIMENTO,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/ConferirPreenchimento.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RelatorioTrimestral',
    path: PATHS.RELATORIO_TRIMESTRAL,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/Trimestral.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RelatorioTrimestralPorRegional',
    path: PATHS.RELATORIO_TRIMESTRAL_POR_REGIONAL,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/TrimestralPorRegional.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RelatorioReceita',
    path: PATHS.RELATORIO_RECEITA,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/Receita.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RelatorioExportacao',
    path: PATHS.RELATORIO_EXPORTACAO,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/Exportacao.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RelatorioOrcamentario',
    path: PATHS.RELATORIO_ORCAMENTARIO,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/Orcamentario.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RelatorioOrcamentarioTrimestral',
    path: PATHS.RELATORIO_ORCAMENTARIO_TRIMESTRAL,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/OrcamentarioTrimestral.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RelatorioOrcamentarioComparativo',
    path: PATHS.RELATORIO_ORCAMENTARIO_COMPARATIVO,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/OrcamentarioComparativo.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RelatorioOrcamentarioComparativoAno',
    path: PATHS.RELATORIO_ORCAMENTARIO_COMPARATIVO_ANO,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/OrcamentarioComparativoAno.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RelatorioMemoriaCalculo',
    path: PATHS.RELATORIO_MEMORIA_CALCULO,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/MemoriaCalculo.vue'
      ),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RelatorioOrcamentoTempoReal',
    path: PATHS.RELATORIO_ORCAMENTO_TEMPO_REAL,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/OrcamentoTempoReal.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RelatorioTotaisCentroCusto',
    path: PATHS.RELATORIO_TOTAIS_CENTRO_CUSTO,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/TotaisCentroCusto.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RelatorioImportacaoSistego',
    path: PATHS.RELATORIO_IMPORTACAO_SISTEGO,
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ '../views/relatorios/ImportacaoSistego.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Embeds',
    path: PATHS.EMBEDS,
    component: () =>
      import(/* webpackChunkName: "embeds" */ '../views/embeds/Embeds.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'EmbedsPowerBI',
    path: PATHS.EMBEDS_PORWER_BI,
    component: () =>
      import(/* webpackChunkName: "embeds" */ '../views/embeds/PowerBI.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Unauthorized',
    path: PATHS.UNAUTHORIZED,
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ '../views/unauthorized/Unauthorized.vue'
      ),
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () =>
      import(
        /* webpackChunkName: "notFound" */ '../views/notFound/NotFound.vue'
      ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from) => {
  const { user, isLoggedSGCCIn } = store.getters

  if (isLoggedSGCCIn && to.name === 'Auth') {
    return { name: 'Home' }
  }
  if (to.meta.requiresAuth) {
    if (!isLoggedSGCCIn && !localStorage.getItem('tokenSGCC')) {
      return { name: 'Auth' }
    }
    if (to.meta.requiresAdmin && !user.isAdmin) {
      return { name: 'Unauthorized' }
    }
  }
})

router.afterEach(async (to, from) => {
  if (!store.getters.isLoggedSGCCIn && to.meta.requiresAuth) {
    await store.dispatch('logout')
    router.push(PATHS.AUTH)
  }
})

export default router
